export default __webpack_public_path__ + "static/media/level_6.c94b8d83.jpg";